// A small pulsing "!" dot that marks an area needing attention. The parent
// element should be position:relative; the badge pins to its top-right corner.
import React from 'react';
import '../styles/AttentionBadge.css';

export default function AttentionBadge({ label = '!', title = 'Needs attention', className = '' }) {
  return (
    <span
      className={`attention-badge ${className}`.trim()}
      role="status"
      aria-label={title}
      title={title}
    >
      {label}
    </span>
  );
}
